import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BasePage } from 'src/app/pages/base.page';
import { Bid } from 'src/app/shared/models/gql/bid.model';
import { ConfirmBookingComponent } from '../confirm-booking/confirm-booking.component';

@Component({
  selector: 'app-worker-bid',
  templateUrl: './worker-bid.component.html',
  styleUrls: ['./worker-bid.component.scss'],
})
export class WorkerBidComponent extends BasePage implements OnInit {
  @Input() bid: Bid;

  @Input() noMsg = false;

  @Input() channelUrl;

  showViewMore = false;

  readMore = false;

  constructor(
    public router: Router,
    public modalController: ModalController,
  ) {
    super('WorkerBidComponent');
  }

  ngOnInit(): void {
    this.showViewMore = this.bid?.comment?.length > 200;
  }

  viewBidder(): void {
    this.router.navigate([`/search/view/${this.bid?.user?.id}`, { job_id: this.bid?.postedJob?.id }]);
  }

  async book(): Promise<void> {
    const modal = await this.modalController.create({
      component: ConfirmBookingComponent,
      componentProps: {
        name: this.bid?.user?.truncatedName,
        jobId: this.bid?.postedJob?.id,
        user_id: this.bid?.user?.id,
      },
      showBackdrop: true,
      cssClass: 'fullpage-modal',
    });

    // https://github.com/ionic-team/ionic-framework/issues/26872
    modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

    modal.present();
  }
}
